import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { PostEntity } from '../post/post.entity';
import { UserEntity } from "../user/user.entity";
@Entity('post_jobs')
export class PostJobsEntity {  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("int",{
    nullable:false,
    name:"post_id"
  })
  postId:number;
  @Column("int",{
    nullable:true,
    name:"user_id"
  })
  userId:number;
  @Column("varchar",{
    nullable:true,
    length:2000,
    name:'name'
  })
  name:string;
  @Column("varchar",{
    nullable:true,
    length:100,
    name:'mobile'
  })
  mobile:string;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"email"
  })
  email:string;
  @Column("text",{
    nullable: true,
    name:"tech_catg"
  })
  techCategory:string;
  @Column("date",{
    nullable:true,
    name:"exp_dt"
  })
  expDate:string;
  @Column("varchar",{
    nullable: true,
    length:5000,
    name:"resume"
  })
  resume:string;
  @Column("int",{
    nullable:false,
    default:0,
    name:"del_flag"  
  })
  delFlag:number;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  
  @ManyToOne(() => PostEntity, (post: PostEntity) => post.postjobs)
  @JoinColumn({ name: 'post_id' })
  post: PostEntity;
  @ManyToOne(() => UserEntity, (user: UserEntity) => user.postjobs)
  @JoinColumn({name: 'user_id'})
  user: UserEntity;
}